export const industries = [
  'Financial Services',
  'Technology',
  'Healthcare & Life Sciences',
  'Energy & Infrastructure',
  'Industrial & Manufacturing',
  'Consumer & Retail',
  'Professional Services',
  'Public Sector & Not-for-Profit',
  'Real Estate',
  'Other',
];

export const experienceRanges = ['Under 5 years', '5–10 years', '10–15 years', '15–20 years', '20+ years'];

export const roleTypes = [
  'Board / Non-Executive Director',
  'C-suite executive',
  'Senior leadership',
  'Specialist or technical leadership',
  'Senior professional',
  'Open to discussion',
];

export const enquiryTypes = [
  'Discussing a search',
  'Board or non-executive search',
  'Talent advisory',
  'Candidate enquiry',
  'Other',
];
